import { render, staticRenderFns } from "./Question_show.vue?vue&type=template&id=3685b957&"
import script from "./Question_show.vue?vue&type=script&lang=js&"
export * from "./Question_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports